import dateFnsFormat from 'date-fns/format'
import { es } from 'date-fns/locale'
import dateFnsParse from 'date-fns/parse'
import React, { useState, useEffect } from 'react'
import { DateUtils } from 'react-day-picker'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { Form, Icon, Dropdown, Input } from 'semantic-ui-react'

export default function DateTimeInput(props) {
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
  const [timeValue, setTimeValue] = useState('')

  // (date: Date?, format: string? | string[]?, locale: string?) ⇒ string
  const formatDate = (date, format, locale = es) => {
    return dateFnsFormat(date, format, { locale })
  }

  // (str: string?, format: string? | string[]?, locale: string?) ⇒ Date | void
  const parseDate = (str, format, locale = es) => {
    const parsed = dateFnsParse(str, format, { locale })

    if (DateUtils.isDate(parsed)) {
      return parsed
    }

    return undefined
  }

  // Generar opciones de años (últimos 10 años y próximos 5 años)
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear()
    const years = []
    for (let i = currentYear - 10; i <= currentYear + 5; i++) {
      years.push({
        key: i,
        text: i.toString(),
        value: i
      })
    }
    return years
  }

  // Generar opciones de meses
  const generateMonthOptions = () => {
    const months = [
      { key: 0, text: 'Enero', value: 0 },
      { key: 1, text: 'Febrero', value: 1 },
      { key: 2, text: 'Marzo', value: 2 },
      { key: 3, text: 'Abril', value: 3 },
      { key: 4, text: 'Mayo', value: 4 },
      { key: 5, text: 'Junio', value: 5 },
      { key: 6, text: 'Julio', value: 6 },
      { key: 7, text: 'Agosto', value: 7 },
      { key: 8, text: 'Septiembre', value: 8 },
      { key: 9, text: 'Octubre', value: 9 },
      { key: 10, text: 'Noviembre', value: 10 },
      { key: 11, text: 'Diciembre', value: 11 }
    ]
    return months
  }

  // Manejar cambio de mes
  const handleMonthChange = (event, { value }) => {
    const newMonth = new Date(currentYear, value, 1)
    setCurrentMonth(newMonth)
  }

  // Manejar cambio de año
  const handleYearChange = (event, { value }) => {
    const newMonth = new Date(value, currentMonth.getMonth(), 1)
    setCurrentMonth(newMonth)
    setCurrentYear(value)
  }

  // Manejar cambio de hora
  const handleTimeChange = (event, { value }) => {
    setTimeValue(value)
    // Combinar fecha y hora
    if (props.value && value) {
      const [hours, minutes] = value.split(':')
      const newDateTime = new Date(props.value)
      newDateTime.setHours(parseInt(hours), parseInt(minutes))
      props.onChange(newDateTime)
    }
  }

  // Manejar cambio de fecha
  const handleDateChange = (date) => {
    if (date && timeValue) {
      // Combinar fecha con hora existente
      const [hours, minutes] = timeValue.split(':')
      const newDateTime = new Date(date)
      newDateTime.setHours(parseInt(hours), parseInt(minutes))
      props.onChange(newDateTime)
    } else {
      props.onChange(date)
    }
  }

  // Actualizar el mes actual cuando cambie el valor
  useEffect(() => {
    if (props.value) {
      setCurrentMonth(props.value)
      setCurrentYear(props.value.getFullYear())
      // Extraer hora del valor
      const timeStr = formatDate(props.value, 'HH:mm')
      setTimeValue(timeStr)
    }
  }, [props.value])

  return (
    <Form.Field error={props.error} required={props.required}>
      <label>{props.icon && <Icon name={props.icon} />} {props.label}</label>

      {/* Selectores de Mes y Año */}
      <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
        <Dropdown
          placeholder="Mes"
          selection
          options={generateMonthOptions()}
          value={currentMonth.getMonth()}
          onChange={handleMonthChange}
          style={{ minWidth: '120px' }}
        />
        <Dropdown
          placeholder="Año"
          selection
          options={generateYearOptions()}
          value={currentYear}
          onChange={handleYearChange}
          style={{ minWidth: '80px' }}
        />
      </div>

      {/* DayPickerInput con el mes seleccionado */}
      <DayPickerInput
        placeholder={props.placeholder || props.label}
        format={props.format}
        formatDate={formatDate}
        parseDate={parseDate}
        value={props.value || ''}
        onDayChange={handleDateChange}
        dayPickerProps={{
          month: currentMonth,
          onMonthChange: setCurrentMonth,
          locale: es
        }}
      />

      {/* Selector de hora */}
      <div style={{ marginTop: '10px' }}>
        <Input
          type="time"
          placeholder="Hora"
          value={timeValue}
          onChange={handleTimeChange}
          style={{ width: '120px' }}
        />
      </div>
    </Form.Field>
  )
}

DateTimeInput.defaultProps = {
  label: 'Fecha y Hora',
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: null,
  onChange: () => { },
  format: 'dd/MM/yyyy',
}
